/* global carouselInlineWidget */

(() => {
	const DEFAULT_WIDGET_ID = 'reviewsio-carousel-widget';
	const DEFAULT_CONFIG_ID = 'reviewsio-carousel-config';
	const CONFIG_SELECTOR = 'script[data-reviewsio-carousel-config]';
	const DEFAULT_REVIEW_TYPES = 'company, product, third_party';
	const MAX_INIT_ATTEMPTS = 30;
	const RETRY_DELAY_MS = 200;

	const buildWidgetConfig = ({ store, reviewType }) => ({
		store,
		sku: '',
		lang: 'en',
		carousel_type: 'default',
		styles_carousel: 'CarouselWidget--sideHeader--withcards ',
		options: {
			general: {
				review_type: reviewType,
				min_reviews: '3',
				max_reviews: '10',
				address_format: 'CITY, COUNTRY',
				// Auto-scroll speed in ms (3000 = 3s). Set false to disable.
				enable_auto_scroll: 3000,
				enable_pause_button: false,
				enable_sorting: false,
			},
			header: {
				enable_overall_stars: true,
				rating_decimal_places: 2,
			},
			reviews: {
				enable_customer_name: true,
				enable_customer_location: true,
				enable_verified_badge: true,
				enable_subscriber_badge: true,
				enable_recommends_badge: true,
				enable_photos: true,
				enable_videos: true,
				enable_review_date: true,
				disable_same_customer: false,
				min_review_percent: 4,
				third_party_source: true,
				hide_empty_reviews: false,
				enable_product_name: true,
				tags: '',
				branch: '',
				enable_branch_name: false,
				// enable_syndication: true,
			},
			popups: {
				enable_review_popups: true,
				enable_helpful_buttons: true,
				enable_helpful_count: true,
				enable_share_buttons: true,
			},
		},
		translations: {
			verified_customer: 'Verified Customer',
		},
		styles: {
			'--base-font-size': '16px',
			'--base-maxwidth': '100%',
			'--reviewsio-logo-style': 'var(--logo-normal)',
			'--common-star-color': '#F8CC61',
			'--common-star-disabled-color': ' rgba(0,0,0,0.25)',
			'--medium-star-size': ' 22px',
			'--small-star-size': '22px',
			'--x-small-star-size': '22px',
			'--x-small-star-display': 'inline-flex',
			'--header-order': '1',
			'--header-width': '280px',
			'--header-bg-start-color': '#fff',
			'--header-bg-end-color': '#e7e7e7',
			'--header-gradient-direction': '150deg',
			'--header-padding': '1.5em',
			'--header-border-width': '0px',
			'--header-border-color': 'rgba(0,0,0,0.1)',
			'--header-border-radius': '0px',
			'--header-shadow-size': '10px',
			'--header-shadow-color': 'rgba(0, 0, 0, 0.05)',
			'--header-star-color': '#F8CC61',
			'--header-disabled-star-color': 'inherit',
			'--header-heading-text-color': '#1a1a1a',
			'--header-heading-font-size': 'inherit',
			'--header-heading-font-weight': 'inherit',
			'--header-heading-line-height': 'inherit',
			'--header-heading-text-transform': 'uppercase',
			'--header-subheading-text-color': '#1a1a1a',
			'--header-subheading-font-size': 'inherit',
			'--header-subheading-font-weight': '300',
			'--header-subheading-line-height': 'inherit',
			'--header-subheading-text-transform': 'inherit',
			'--item-maximum-columns': '4',
			'--item-background-start-color': '#ffffff',
			'--item-background-end-color': '#ffffff',
			'--item-gradient-direction': '135deg',
			'--item-padding': '1.5em',
			'--item-border-width': '0px',
			'--item-border-color': 'rgba(0,0,0,0.1)',
			'--item-border-radius': '0px',
			'--item-shadow-size': '10px',
			'--item-shadow-color': 'rgba(0,0,0,0.05)',
			'--heading-text-color': '#1a1a1a',
			'--heading-text-font-weight': ' 600',
			'--heading-text-font-family': ' inherit',
			'--heading-text-line-height': ' 1.4',
			'--heading-text-letter-spacing': '0',
			'--heading-text-transform': 'none',
			'--body-text-color': '#1a1a1a',
			'--body-text-font-weight': '400',
			'--body-text-font-family': ' inherit',
			'--body-text-line-height': ' 1.4',
			'--body-text-letter-spacing': '0',
			'--body-text-transform': 'none',
			'--scroll-button-icon-color': '#1a1a1a',
			'--scroll-button-icon-size': '28px',
			'--scroll-button-bg-color': 'transparent',
			'--scroll-button-border-width': '1px',
			'--scroll-button-border-color': '#1a1a1a',
			'--scroll-button-border-radius': '60px',
			'--scroll-button-shadow-size': '1px',
			'--scroll-button-shadow-color': 'rgba(0,0,0,0.1)',
			'--scroll-button-horizontal-position': '20px',
			'--scroll-button-vertical-position': '0px',
			'--badge-icon-color': '#54C63A',
			'--badge-icon-font-size': '24px',
			'--badge-text-color': '#1a1a1a',
			'--badge-text-font-size': '14px',
			'--badge-text-letter-spacing': 'inherit',
			'--badge-text-transform': 'inherit',
			'--author-font-size': '16px',
			'--author-font-weight': '600',
			'--author-text-transform': 'inherit',
			'--photo-video-thumbnail-size': '60px',
			'--photo-video-thumbnail-border-radius': '0px',
			'--popup-backdrop-color': 'rgba(0,0,0,0.75)',
			'--popup-color': '#ffffff',
			'--popup-star-color': 'inherit',
			'--popup-disabled-star-color': 'inherit',
			'--popup-heading-text-color': 'inherit',
			'--popup-body-text-color': 'inherit',
			'--popup-badge-icon-color': 'inherit',
			'--popup-badge-icon-font-size': '19px',
			'--popup-badge-text-color': 'inherit',
			'--popup-badge-text-font-size': '14px',
			'--popup-border-width': '0px',
			'--popup-border-color': 'rgba(0,0,0,0.1)',
			'--popup-border-radius': '0px',
			'--popup-shadow-size': '0px',
			'--popup-shadow-color': 'rgba(0,0,0,0.1)',
			'--popup-icon-color': '#1a1a1a',
			'--tooltip-bg-color': '#0E1311',
			'--tooltip-text-color': '#ffffff',
		},
	});

	const getLiquidConfig = () => {
		const configNode =
			document.querySelector(CONFIG_SELECTOR)
			|| document.getElementById(DEFAULT_CONFIG_ID);
		if (!configNode || !configNode.textContent) {
			return {};
		}

		try {
			const { reviewsCardCarousel = {} } = JSON.parse(configNode.textContent);
			return reviewsCardCarousel;
		} catch (error) {
			console.error('Invalid Reviews.io carousel config JSON.', error);
			return {};
		}
	};

	const scheduleInitRetry = (attempt, retryCallback) => {
		if (attempt >= MAX_INIT_ATTEMPTS) {
			return;
		}

		setTimeout(() => {
			retryCallback(attempt + 1);
		}, RETRY_DELAY_MS);
	};

	const initReviewsCarouselWidget = (attempt = 0) => {
		const {
			widgetId = DEFAULT_WIDGET_ID,
			store = window.location.hostname,
			reviewType = DEFAULT_REVIEW_TYPES,
		} = getLiquidConfig();

		const widgetRoot = document.getElementById(widgetId);
		if (!widgetRoot || widgetRoot.dataset.initialized === 'true') {
			return;
		}

		if (typeof carouselInlineWidget !== 'function') {
			scheduleInitRetry(attempt, initReviewsCarouselWidget);
			return;
		}

		const widgetConfig = buildWidgetConfig({ store, reviewType });

		// Reviews.io exposes a lowercase constructor on window.
		// eslint-disable-next-line new-cap
		const widgetInstance = new carouselInlineWidget(widgetId, widgetConfig);
		if (widgetInstance) {
			widgetRoot.dataset.initialized = 'true';
		}
	};

	document.addEventListener('DOMContentLoaded', () => {
		initReviewsCarouselWidget();
	});
})();
